import { Button } from "@components/ui/button";
import {
  closestCenter,
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useState } from "react";
import DragChild from "./DragChild";

import { BlockQuoteIcon, DescriptionIcon } from "@assets/icons";
import { MessageCircleQuestion } from "lucide-react";

const DragContainer = ({
  fields,
  control,
  append,
  move,
  getValues,
  setValue,
  remove,
}: {
  fields: any[];
  control: any;
  append: any;
  move: any;
  getValues: any;
  setValue: any;
  watch: any;
  remove: any;
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  //   const items = watch("items");

  // Drag end handler for dnd-kit

  function handleDragEnd(event: any) {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = fields.findIndex((item) => item.id === active.id);
      const newIndex = fields.findIndex((item) => item.id === over.id);
      if (oldIndex !== -1 && newIndex !== -1) {
        // Update react-hook-form field array ordering using move
        move(oldIndex, newIndex);
      }
    }
    setIsDragActive(false);
  }

  function appendChildToDescription(descId: number) {
    console.log("description id", descId);
    const currentItems = getValues("items");
    console.log(currentItems, "curr");
    const updatedItems = currentItems.map((item: any) => {
      if (item.type === "quotation" && item.id === descId) {
        const newChildId = (item.children?.length ?? 0) + 1;
        return {
          ...item,
          children: [
            ...(item.children ?? []),
            { id: newChildId, question: "", answer: "" },
          ],
        };
      } else {
        return { ...item };
      }
    });
    setValue("items", updatedItems);
  }

  const [isDragActive, setIsDragActive] = useState<boolean>(false);
  return (
    <div className="w-full">
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
        onDragMove={() => setIsDragActive(true)}
        onDragStart={() => setIsDragActive(true)}
        onDragCancel={() => setIsDragActive(false)}
      >
        <SortableContext items={fields} strategy={verticalListSortingStrategy}>
          {fields.map((field, index) => (
            <DragChild
              currentItems={getValues("items")}
              field={field}
              control={control}
              id={index}
              key={field.id}
              remove={remove}
              getValues={getValues}
              setValue={setValue}
              isDragActive={isDragActive}
              addChildToDescription={appendChildToDescription}
            />
          ))}
        </SortableContext>
      </DndContext>
      <div className="flex justify-center w-full items-center">
        {" "}
        <div className="flex gap-[20px]  px-[20px] py-[10px] p-2 rounded-md border w-fit  my-10 justify-center items-center shadow-sm">
          <blockquote className="text-[#1DA077] font-medium">
            Add More
          </blockquote>

          <Button
            className="block"
            variant={"outline"}
            type="button"
            title="Add Question and Answer"
            onClick={(e) => {
              e.stopPropagation();
              append({
                id: fields.length,
                type: "quotation",
                title: "",
                children: [
                  {
                    id: 1,
                    question: "",
                    answer: "",
                  },
                ],
              });
            }}
          >
            <MessageCircleQuestion color="#969696" />
          </Button>
          <Button
            className="block"
            type="button"
            variant={"outline"}
            title="Add description"
            onClick={(e) => {
              e.stopPropagation();
              append({
                id: fields.length,
                type: "description",
                title: "",
                description: "",
              });
            }}
          >
            {" "}
            <DescriptionIcon />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DragContainer;
